<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Associar Documento Despesa</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onCreate()"
                      v-b-tooltip
                      title="Associar Documento"
                      ><i class="ft-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="table-responsive">
                  <b-col md="6" offset-md="6">
                    <b-row no-gutters>
                      <b-col class="p-0">
                        <label>Vlr. total trecho calculado</label>
                        <currency-input
                          class="form-control"
                          v-model="form.vlr_total_trechos"
                          placeholder="Vlr. total trechos"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: 'R$ ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                      <b-col class="p-0">
                        <label>Qtd. Trechos</label>
                        <currency-input
                          class="form-control"
                          v-model="form.qtd_trechos"
                          placeholder="Quantidade de trechos"
                          disabled
                          :auto-decimal-mode="true"
                          :currency="{ prefix: ' ' }"
                          :distraction-free="getCurrency"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('associardocumentodespesa.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/associardocumentodespesa"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="peduncatr_id"
                    pagination-path=""
                    @vuetable:pagination-data="onPaginationData"
                    detail-row-component="auditoria-detalhes"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="carga" slot-scope="props">
                      <span>{{ props.rowData.num_carga }}</span>
                    </template>
                    <template slot="transportadora" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.fornecedor != null &&
                          props.rowData.fornecedor.pessoa_juridica != null
                        "
                        >{{
                          props.rowData.fornecedor.pessoa_juridica.razao_social
                        }}</span
                      >
                    </template>
                    <template slot="transportadora_cnpj" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.fornecedor != null &&
                          props.rowData.fornecedor.pessoa_juridica != null
                        "
                        >{{
                          getFormattedPessoaCnpj(
                            props.rowData.fornecedor.pessoa_juridica
                          )
                        }}</span
                      >
                    </template>
                    <template slot="vlr_custo" slot-scope="props">
                      <span>{{ formatNumber(props.rowData.vlr_custo) }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 4"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 5"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AuditoriaModal ref="auditoriamodal" />
      <AuditoriaConfirmModal ref="auditoriaconfirmmodal" />
      <AssociarDocumentoDespesaModal
        ref="associardocumentodespesamodal"
        :metodo="onFilterReset"
      />
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import moment from "moment";
import AssociarDocumentoDespesaFilterBar from "./AssociarDocumentoDespesaFilterBar.vue";
import AssociarDocumentoDespesaModal from "./AssociarDocumentoDespesaModal.vue";
import AuditoriaModal from "./AuditoriaModal.vue";
import AssociarDocumentoDespesaDetalhes from "./AssociarDocumentoDespesaDetalhes.vue";
import AuditoriaDetalhes from "./AuditoriaDetalhes.vue";
import AuditoriaConfirmModal from "./AuditoriaConfirmModal.vue";
import accounting from "accounting";

import {
  formatCNPJFromParts,
  getFormattedPessoaCnpj as getFormattedPessoaCnpjUtil,
} from "../utils";

Vue.component("auditoria-detalhes", AuditoriaDetalhes);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    AuditoriaModal,
    AssociarDocumentoDespesaModal,
    AuditoriaConfirmModal,
    "vuetable-filterbar": AssociarDocumentoDespesaFilterBar,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      dados: [],
      dadosSearchAll: [],
      dataExport: [],
      optionsStatus: [],
      optionsTpTrecho: [],
      optionsTpLiberacao: [],
      optionsParamMotivo: [],
      optionsTpOperacao: [],
      optionsStatusAprovar: [],
      trechos: [],
      trechos_valor: 0,
      filter_data_store: {},
      filtros_form: new Form({
        dt_ini: "",
        dt_fim: "",
        transportadora: "",
        carga_ini: "",
        carga_fim: "",
        num_trecho_ini: "",
        num_trecho_fim: "",
        tp_operacao: ""
      }),
      form: new Form({
        qtd_trechos: 0,
        vlr_total_trechos: 0,
      }),
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalDoc: false,
      showModalConta: false,
      isFullscreen: false,
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:carga",
          title: "Carga",
          sortField: "carga",
        },
        {
          name: "num_trecho",
          title: "N° do Trecho",
          sortField: "num_trecho",
        },
        {
          name: "__slot:transportadora",
          title: "Transportadora",
          sortField: "transportadora",
        },
        {
          name: "__slot:transportadora_cnpj",
          title: "CNPJ",
          sortField: "cnpj",
        },
        {
          name: "__slot:vlr_custo",
          title: "Valor do Calculo",
          sortField: "vlr_custo",
        },
        {
          name: "param_motivo.descr",
          title: "Motivo",
          sortField: "motivo",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
      ],
      css: {
        tableClass: "table table-striped",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function (data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.dt_ini = this.filter_data_store.dt_ini;
          this.filtros_form.dt_fim = this.filter_data_store.dt_fim;
          this.filtros_form.transportadora =
            this.filter_data_store.transportadora;
          this.filtros_form.carga_ini = this.filter_data_store.carga_ini;
          this.filtros_form.carga_fim = this.filter_data_store.carga_fim;
          this.filtros_form.num_trecho_ini =
            this.filter_data_store.num_trecho_ini;
          this.filtros_form.num_trecho_fim =
            this.filter_data_store.num_trecho_fim;
          this.filtros_form.num_trecho_fim =
            this.filter_data_store.num_trecho_fim;
          this.filtros_form.tp_operacao =
            this.filter_data_store.tp_operacao;
          this.filtros_form.param_motivo =
            this.filter_data_store.param_motivo;
          this.filtros_form
            .post("/api/associardocumentodespesa/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              var contagem = 0;
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj.peduncatr_id));
              });
              this.dadosSearchAll = response;
              this.loadingData = false;
            })
            .catch((errors) => {
              this.loadingData = false;
              new ReturnApi(errors, this);
            });
        } else {
          this.dadosSearchAll = [];
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        dt_ini: data_filter.dt_ini,
        dt_fim: data_filter.dt_fim,
        transportadora: data_filter.transportadora.value,
        carga_ini: data_filter.carga_ini,
        carga_fim: data_filter.carga_fim,
        num_trecho_ini: data_filter.num_trecho_ini,
        num_trecho_fim: data_filter.num_trecho_fim,
        param_motivo: data_filter.param_motivo,
        tp_operacao: data_filter.tp_operacao
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterShowHide() {
      if (this.vuetableFilterRow) {
        this.$store.commit("setVuetableFilterRow", false);
      } else {
        this.$store.commit("setVuetableFilterRow", true);
      }
    },
    onLoaded: function () {
      this.dataExport.push(this.$refs.vuetable.tableData);
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
      this.dataExport.forEach((obj2) => {
        obj2.forEach((obj3) => {
          this.dados.push({
            peduncatr_id: obj3.peduncatr_id,
            vlr_custo: obj3.vlr_custo,
          });
        });
      });
      this.$watch(
        () => {
          console.log(this.$refs.vuetable.selectedTo);
          return this.$refs.vuetable.selectedTo;
        },
        (obj) => {          
          if(this.dadosSearchAll.length == 0){
            this.somaValoresSelectedTo(obj);
          } else {
            this.somaValores(obj);
          }
        }
      );
    },
    somaValores(obj) {
      this.form.qtd_trechos = 0;
      this.form.vlr_total_trechos = 0;

      obj.forEach((item) => {
        var trecho = this.dadosSearchAll.filter((item2) => item2.peduncatr_id === item);
        if (trecho[0].vlr_custo != null) {
          this.form.vlr_total_trechos =
          parseFloat(trecho[0].vlr_custo) +
          this.form.vlr_total_trechos; // aqui
        }
        this.form.qtd_trechos++;
      });

      if (this.$refs.vuetable.selectedTo.length == 0) {
        this.form.qtd_trechos = 0;
        this.form.vlr_total_trechos = 0;
      }
      this.form.vlr_total_trechos = Math.round(this.form.vlr_total_trechos, -2);
    },
    somaValoresSelectedTo(obj) {
      this.form.qtd_trechos = 0;
      this.form.vlr_total_trechos = 0;

      obj.forEach((item) => {
        var trecho = this.dados.filter((item2) => item2.peduncatr_id === item);

        if (trecho[0].vlr_custo != null) {
          this.form.vlr_total_trechos =
          parseFloat(trecho[0].vlr_custo) +
          this.form.vlr_total_trechos;
        }

        this.form.qtd_trechos++;
      });

      this.form.vlr_total_trechos = Math.round(this.form.vlr_total_trechos, -2);

      if (this.$refs.vuetable.selectedTo.length == 0) {
        this.form.qtd_trechos = 0;
        this.form.vlr_total_trechos = 0;
      }
    },
    onLiberar(data) {
      this.$refs.auditoriamodal.onCreate(data);
    },
    onConfirm(data) {
      this.$refs.auditoriaconfirmmodal.onCreate(data);
    },
    onCreate() {
      if (this.$refs.vuetable.selectedTo.length == 0) {
        alert("Selecione no mínimo um trecho.");
      } else {
        this.trechos = [];
        this.trechos_valor = 0;
        this.trechos_valor = this.form.vlr_total_trechos;
        this.$refs.vuetable.selectedTo.forEach((peduncatr_id) => {
          this.trechos.push(peduncatr_id);
        });
        this.$refs.associardocumentodespesamodal.onCreate(
          this.trechos,
          this.trechos_valor
        );
      }
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.peduncatr_id);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2);
    },
    DateFormat: function (date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getLivGeral() {
      this.helpForm
        .get("/api/associardocumentodespesa/jsonlist")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);

          response.status.forEach((obj) => {
            this.optionsStatus.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          // response.status_aprovar.forEach((obj) => {
          //   this.optionsStatusAprovar.push({
          //     text: obj.descr,
          //     value: obj.valor,
          //   });
          // });

          response.tp_liberacao.forEach((obj) => {
            this.optionsTpLiberacao.push({
              text: obj.descr,
              value: obj.valor,
            });
          });

          response.tp_doc.forEach((obj) => {
            this.optionsTpTrecho.push({
              label: obj.descr,
              value: obj.valor,
            });
          });

          response.param_motivo.forEach((obj) => {
            this.optionsParamMotivo.push({
              label: obj.descr,
              value: obj.parmot_id,
            });
          });

          response.tp_operacao.forEach((obj) => {
            this.optionsTpOperacao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    getFormattedPessoaCnpj(pessoaJuridica) {
      return getFormattedPessoaCnpjUtil(pessoaJuridica);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
  },
};
</script>
<style>
.form-check {
  padding: 0 1.25rem;
}
</style>